/**
 * DATA-FLYWHEEL-1 — per-tenant performance learning loop schemas.
 * Patent surface: F-DATA-FLYWHEEL-001.
 */
import { z } from 'zod';

export const TenantLearningInsightCategory = z.enum([
  'breach-prevention',
  'cost-optimization',
  'threshold-tuning',
  'customer-fit-feedback',
  'operational-pattern',
  'demand-pattern',
]);

export const TenantLearningInsight = z.object({
  id: z.string(),                          // ULID
  tenantId: z.string(),
  category: TenantLearningInsightCategory,
  headline: z.string().max(120),
  body: z.string().max(1500),
  factsCited: z.array(z.string()),
  appliesAcrossTenants: z.boolean().default(false), // cross-tenant; platform tier only
  affectedSurfaces: z.array(z.string()),
  confidence: z.number().min(0).max(1),
  generatedAt: z.string(),
  correlationId: z.string(),
  softDeleted: z.boolean().default(false),
});

export const TenantOutcomeAggregate = z.object({
  id: z.string(),                          // ULID
  tenantId: z.string(),
  windowDays: z.number().int().positive(),
  windowStartAt: z.string(),
  computedAt: z.string(),
  breachesDetected: z.number().int().min(0),
  breachesAvoided: z.number().int().min(0),
  avgCostPerShipmentCents: z.number().min(0),
  marketCostPerShipmentCents: z.number().min(0).nullable().default(null),
  thresholdOptimizationGainsCents: z.number().min(0),
  customerFitScore: z.number().min(0).max(1).nullable().default(null),
  shipmentCount: z.number().int().min(0),
  softDeleted: z.boolean().default(false),
});
